// Third Party
import React from 'react';

// Components
import { QuickSearch } from '../common';

// Enums
import { QUICK_SEARCH_TYPE, QUICK_SEARCH_REDUCER_NAME } from '../../../redux/modules/quick-search';
import QuickSearchItem from '@/types/quick-search-item';

type Props = {
  dark?: boolean;
  onAddItem: (item: QuickSearchItem) => void;
  withItemScreener?: boolean;
  onScreenerButtonClick?: () => void;
};

const EditPortfolioQuickSearch = ({ dark, onAddItem, withItemScreener, onScreenerButtonClick }: Props) => (
  <QuickSearch
    dark={dark}
    targetReducer={QUICK_SEARCH_REDUCER_NAME.EDIT_PORTFOLIO}
    allowedTypes={[QUICK_SEARCH_TYPE.FUNDS, QUICK_SEARCH_TYPE.STOCKS, QUICK_SEARCH_TYPE.BONDS, QUICK_SEARCH_TYPE.BENCHMARK_PROXIES]}
    className="edit-portfolio-quick-search"
    onItemSelection={(item: QuickSearchItem) => onAddItem(item)}
    withItemScreener={withItemScreener}
    onScreenerButtonClick={onScreenerButtonClick}
  />
);

export default EditPortfolioQuickSearch;
